import React from 'react'

import * as googleModel from '@/shared/lib/google-login/model'
import { useWatcher, useWatcherOnce } from '@/shared/lib/hooks'

import { renderGoogleButton } from '../lib'
import * as model from './model'

type GooglePairButtonProps = {
    state: string
    width?: number
    height?: string
}

export function GooglePairButton(props: GooglePairButtonProps) {
    const googleButtonRef = React.useRef<HTMLDivElement>(null)

    useWatcher(googleModel.accessTokenReceived, ({ accessToken, state }) => {
        // NOTE: может быть на странице несколько кнопок, и callback вызывается для всех
        if (props.state !== state) {
            return
        }

        model.googlePairInit({ accessToken })
    })

    useWatcherOnce(googleModel.$googleInitialized, (initialized) => {
        if (initialized && googleButtonRef.current) {
            renderGoogleButton({
                buttonRef: googleButtonRef.current,
                width: props.width,
                state: props.state,
            })
            return true
        }
        return false
    })

    return (
        // biome-ignore lint/nursery/noInlineStyles: height is a runtime prop value
        <div ref={googleButtonRef} style={{ height: props.height ?? '40px' }} />
    )
}
